import React from "react";
import { UseFormRegisterReturn } from "react-hook-form";

interface SelectDropdownProps {
    options: { label: string, value: string }[];
    register: UseFormRegisterReturn;
    label: string;
    name?: string;
    disabled?: boolean;
}

const SelectDropdown: React.FC<SelectDropdownProps> = ({
    options,
    register,
    label,
    name,
    disabled
}) => {
    return (
        <div className="form-group">
            <label className="form-label" htmlFor={name}>{label}</label>
            <select
                id={name}
                className="form-control"
                {...register}
                disabled={disabled}
                name={name}
            >
                <option value={""}>Select an option</option>
                {options.map((option, index) => (
                    <option key={index} value={option.value}>
                        {option.label}
                    </option>
                ))}
            </select>
        </div>
    );
};

export default SelectDropdown;
